import { render, staticRenderFns } from "./IconKununu.vue?vue&type=template&id=bf4224e8"
import script from "./IconKununu.vue?vue&type=script&lang=js"
export * from "./IconKununu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports